/* eslint-disable max-lines-per-function */
import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    Grid,
    Typography,
    TableFooter,
    Button
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';

import BulkInsertRow from './Row';
import { Close } from '@material-ui/icons';
import { checkPermissions } from '#/permissions';
import { roles } from '#/constants';

const BulkInsertTable = props => {

    const {
        data,
        styles,
        onSubmit,
        newOrder,
        closeModal,
        buttonCloseLabel,
        buttonSubmitLabel,
        deleteOrder,
        saveOrder,
        amenityTypes,
        amenityTags,
        unitTypeMappings,
        role,
        unitMenu,
        paidMenu,
        makeAmenityList,
        findUnitType
    } = props;

    const makeRowProps = data => ({
        data,
        styles,
        newOrder,
        deleteOrder,
        saveOrder,
        amenityTypes,
        amenityTags,
        unitTypeMappings,
        role,
        unitMenu,
        paidMenu,
        makeAmenityList,
        findUnitType
    });

    const isAdmin = checkPermissions([roles.admin, roles.regional_manager_admin], role);

    const marginStyle = isAdmin
        ? {
            closeStyle: '0%',
            addOrderStyle: '45%',
            saveBulkStyle: '55%',
            coolspam: 6
        }
        : {
            closeStyle: '0%',
            addOrderStyle: '70%',
            saveBulkStyle: '65%',
            coolspam: 3
        };


    return (
        <TableContainer component={Paper} className={styles.tableContainer} >

            <Table className={styles.table} aria-label='simple table'>

                <TableBody className={styles.tableBody}>

                    {data.map(row => (
                        <BulkInsertRow key={row.id} { ...makeRowProps(row) } />
                    ))}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TableCell colSpan={0}>
                            <Grid container>
                                <Grid item lg={6} className={styles.center} style={{ marginLeft: marginStyle.closeStyle }}>
                                    <Typography>

                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            onClick={closeModal}
                                            className={styles.buttonCancel}
                                            startIcon={<Close />}
                                        >
                                            {buttonCloseLabel}
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </TableCell>

                        <TableCell colSpan={marginStyle.coolspam}>
                            <Grid container>
                                <Grid item lg={6} className={styles.center} style={{ marginLeft: marginStyle.addOrderStyle }}>
                                    <Typography>

                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            onClick={newOrder}
                                            className={styles.button}
                                            startIcon={<AddIcon />}
                                        >
                                            Add Order
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </TableCell>

                        <TableCell colSpan={3}>
                            <Grid container>
                                <Grid item lg={8} className={styles.center} style={{ marginLeft: marginStyle.saveBulkStyle }}>
                                    <Typography>

                                        <Button
                                            variant='contained'
                                            color='secondary'
                                            onClick={onSubmit}
                                            className={styles.buttonSubmit}
                                            startIcon={<AddIcon />}
                                        >
                                            {buttonSubmitLabel}
                                        </Button>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
};


export default BulkInsertTable;
